@if (userLoaded()) {
    <div class="h-dvh w-dvw bg-shui-base-1 flex flex-col overflow-hidden">
        @if (showEnvironmentHint()) {
            <app-banner [stage]="stage"></app-banner>
        }
        <app-header></app-header>
        <div class="flex flex-1 min-h-0 overflow-hidden p-4 pt-0 pb-0 gap-2">
            <app-sidebar></app-sidebar>
            <main class="flex-1 overflow-y-auto min-h-0 box-border">
                <router-outlet></router-outlet>
            </main>
        </div>
        <div class="px-4 pb-4 pt-2 box-border">
            <app-footer></app-footer>
        </div>
    </div>
    <app-snackbar-container></app-snackbar-container>
} @else {
    <div data-testid="emea-app-loading" class="h-dvh w-dvw bg-shui-base-1 flex items-center justify-center">
        <div class="flex flex-col items-center gap-8">
            <img
                src="assets/images/healthineers-logo/healthineers-logo-black.svg"
                alt="Siemens Healthineers"
                class="w-48 [html[theme='dark']_&]:hidden"
            />
            <img
                src="assets/images/healthineers-logo/healthineers-logo-white.svg"
                alt="Siemens Healthineers"
                class="w-48 hidden [html[theme='dark']_&]:block"
            />
            <sh-spinner size="s"></sh-spinner>
        </div>
    </div>
}
